import { X } from 'lucide-react';

/**
 * Sprechblase am Teiler zwischen Liste und Karte, beim ersten Besuch am Rechner (Startseite).
 * Steht in der Karte, links am Teiler; der Pfeil zeigt auf den Griff. Wann sie kommt und geht,
 * entscheidet die Seite.
 */
export default function TeilerHinweis({ onClose }: { onClose: () => void }) {
  return (
    <div className="lp-teiler-hinweis" role="status">
      <div>
        <strong>Mehr Liste oder mehr Karte?</strong>
        <p>Zieh den Griff nach links oder rechts.</p>
      </div>
      <button type="button" onClick={onClose} aria-label="Hinweis schließen"><X size={16} aria-hidden /></button>
    </div>
  );
}
